<template>
  <div class="sidesheet">
    <div class="sidesheet__overlay" :class="{ sidesheet__overlay_active: localActive }"></div>

    <div class="sidesheet__wrapper" :class="{ sidesheet__wrapper_active: localActive }">
      <div class="sidesheet__close" @click="closeSidesheet">
        <svg class="lg" width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="17" cy="17.001" r="16.5" stroke="#D3D8DF" />
          <path
            d="M22.9684 22.66C22.5794 23.049 21.9467 23.047 21.5552 22.6555L11.6584 12.7602C11.267 12.3687 11.265 11.736 11.654 11.347C12.043 10.9579 12.6758 10.9599 13.0672 11.3514L22.964 21.2468C23.3555 21.6382 23.3574 22.2709 22.9684 22.66Z"
            fill="#D3D8DF"
          />
          <path
            d="M22.9766 11.3502C22.5852 10.9587 21.9525 10.9567 21.5634 11.3458L11.6585 21.2507C11.2695 21.6397 11.2715 22.2724 11.6629 22.6639C12.0544 23.0554 12.6871 23.0574 13.0761 22.6683L22.9811 12.7634C23.3701 12.3744 23.3681 11.7417 22.9766 11.3502Z"
            fill="#D3D8DF"
          />
        </svg>

        <svg class="sm" width="30" height="30" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.6045 10.6092C10.2154 10.9983 9.58272 10.9963 9.19126 10.6048L3.53712 4.95206C3.14565 4.5606 3.14367 3.92788 3.5327 3.53886C3.92172 3.14984 4.55443 3.15182 4.9459 3.54328L10.6 9.19603C10.9915 9.58749 10.9935 10.2202 10.6045 10.6092Z"
            fill="#8E9CBB"
          />
          <path
            d="M10.6127 3.54209C10.2212 3.15062 9.58849 3.14864 9.19947 3.53767L3.53718 9.19996C3.14816 9.58898 3.15014 10.2217 3.54161 10.6132C3.93307 11.0046 4.56579 11.0066 4.95481 10.6176L10.6171 4.95529C11.0061 4.56627 11.0041 3.93356 10.6127 3.54209Z"
            fill="#8E9CBB"
          />
        </svg>
      </div>

      <div class="sidesheet__header">
        <div v-if="title && !useHtml" class="sidesheet__title">{{ title }}</div>
        <div v-if="title && useHtml" class="sidesheet__title" v-html="title"></div>

        <div class="sidesheet__actions">
          <slot name="actions"></slot>
        </div>
      </div>

      <div class="sidesheet__content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sidesheet",

  props: ["active", "title", "description", "useHtml"],

  data() {
    return {
      localActive: this.active,
    };
  },

  watch: {
    active(value) {
      this.localActive = value;
      const closeOnEscPress = (event) => {
        if (event.keyCode === 27) {
          this.closeSidesheet();
        }
      };
      if (value) {
        window.addEventListener("keyup", closeOnEscPress);
      }
      if (!value) {
        window.removeEventListener("keyup", closeOnEscPress);
      }
    },

    localActive(value) {
      if (!value) this.$emit("close");
    },
  },
  methods: {
    closeSidesheet() {
      this.localActive = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.sidesheet {
  &__overlay {
    width: 100vw;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    left: 0;
    top: 0;
    position: fixed;
    z-index: $z-index-modal-overlay;
    background: black;
    opacity: 0;
    visibility: hidden;

    &_active {
      opacity: 0.7;
      visibility: visible;
    }
  }

  &__wrapper {
    position: fixed;
    right: -1300px;
    width: calc(100vw - 280px);
    max-width: 1120px;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
    z-index: $z-index-modal-block;
    top: 0;
    background: white;
    transition: 0.3s;
    padding: 40px 30px;
    display: flex;
    flex-direction: column;

    &_active {
      right: 0;
    }
  }

  &__close {
    width: 34px;
    height: 34px;
    left: -46px;
    top: 10px;
    position: absolute;
    cursor: pointer;

    .sm {
      display: none;
    }
  }

  &__header {
    flex-basis: 24px;
    display: flex;
    align-items: center;
  }

  &__actions {
    margin-left: auto;
  }

  &__title {
    font: {
      size: 22px;
      weight: 500;
    }
    line-height: 24px;
  }

  &__content {
    height: calc(100% - 24px);
    min-height: 0;
  }

  @media screen and (max-width: 1179.98px) {
    &__wrapper {
      width: calc(100vw - 60px);
    }
  }

  @media screen and (max-width: 767.98px) {
    &__wrapper {
      width: 100vw;
      padding: 24px 12px !important;

      overflow: hidden;
    }

    &__header {
      padding-left: 10px;
      padding-right: 10px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    &__actions {
      margin-left: 0;
      margin-top: 1rem;
    }

    &__content {
      height: auto;
      flex-grow: 1;
      padding-left: 10px;
      padding-right: 10px;
      padding-top: 20px;
      position: relative;
    }

    &__close {
      position: absolute;
      right: 5px !important;
      top: 5px !important;
      margin-bottom: 8px;
      padding: 0;

      display: flex;
      align-items: center;
      justify-content: center;
      left: auto;
      z-index: 301;
      .lg {
        display: none;
      }
      .sm {
        display: block;
      }
    }

    &__title {
      font-size: 15px;
    }
  }
}
</style>
